<template>
  <div>
    <Header></Header>
    <Home></Home>
    <div class="container mb-5">
      <div class="row justify-content-center">
        <h2 class="text-center mb-3">Acerca de F&F Soluciones</h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-center">
          - Visión general - Encontrar una solución novedosa, <br />
          elegante y funcional a tus necesidades
        </h4>
      </div>
      <div class="row mt-5">
        <Card v-for="card in cards" :data="card"></Card>
      </div>
    </div>
    <Gradient></Gradient>
    <div class="container my-5" id="soluciones">
      <h2 class="text-center">Grandes Soluciones</h2>
      <h4 class="text-center">
        Tenemos desarrollos que te ayudaran a cubrir los requerimientos de tu
        empresa.
      </h4>
    </div>
    <Software v-for="software in softwares" :data="software"></Software>
    <Carousel></Carousel>
    <div style="background-color: #D6D6D6">
      <div class="container py-4">
        <div class="row justify-content-center mb-3">
          <h2 style="color: #708482" class="text-center">
            Clientes Satisfechos
          </h2>
        </div>
        <div class="row justify-content-center mb-5">
          <h4 style="color:#708482;" class="text-center">
            Tenemos desarrollos que te ayudarán a cubrir los requerimientos de
            tu empresa.
          </h4>
        </div>
        <div class="row justify-content-between">
          <div class="col-lg-4 col-sm-12 my-4">
            <img
              src="../assets/cliente_tuchip_gris.png"
              alt=""
              width="65%"
              class="mx-auto d-block"
            />
          </div>
          <div class="col-lg-4 col-sm-12 my-4">
            <img
              src="../assets/cliente_att_gris.png"
              alt=""
              width="35%"
              class="mx-auto d-block"
            />
          </div>
          <div class="col-lg-4 col-sm-12 my-4">
            <img
              src="../assets/cliente_movistar_gris.png"
              alt=""
              width="65%"
              class="mx-auto d-block"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container py-5" id="contact">
      <FormContact></FormContact>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Header from "./Header";
import Card from "./Card";
import Home from "./Home";
import Gradient from "./Gradient";
import Software from "./Software";
import FormContact from "./FormContact";
import Footer from "./Footer";
import Carousel from "./Carousel";

export default {
  name: "Landing",
  components: {
    Navbar,
    Header,
    Card,
    Home,
    Gradient,
    Software,
    Carousel,
    FormContact,
    Footer
  },
  data() {
    return {
      softwares: [
        {
          img: `./dist/solucion_cam.png`,
          titulo: `Sistema CAM`,
          subtitulo: `Cam es una plataforma web de consulta autoadministrable.`,
          color: `#00A492`,
          right: true,
          route: `Cam`,
          textos: [
            `Consulta la calidad de tus clientes en segundos desde la plataforma web o en la palma de tu mano con nuestra App disponible para Android®`,
            `Consigue una visión más amplia de tu distribuidora de una manera fácil y certera.`,
            `Sube tus archivos y tu información cobrará significado, todo computado desde la nube.`
          ]
        },
        {
          img: `./dist/solucion_activa_solo.png`,
          titulo: `Activa-Solo`,
          subtitulo: `Es una herramienta que automatiza el proceso de activación para tus sims prepago.`,
          color: `#008DA3`,
          right: false,
          route: `ActivaSolo`,
          textos: [
            `Realiza de manera autónoma y cíclica, los pasos a seguir para la correcta activación de líneas a través de AVS, las veces que sea necesario.`,
            `Ahorra costos en tú operación de activación con menos gastos de nómina.`,
            `Aprovecha tu recurso humano en otras actividades.`
          ]
        },
        {
          img: `./dist/solucion_recarga_te.png`,
          titulo: `Recarga-Te`,
          subtitulo: `Es un sistema que automatiza la realización de recargas a tus sims,en un ambiente de venta a mayoreo o venta individual. Te proponemos la mejor solución a tu operación.`,
          color: `#0064A3`,
          right: true,
          route: `RecargaTe`,
          textos: [
            `Elimina horarios de recarga para tus clientes.`,
            `Tus clientes recibirán su recarga en segundos,`,
            `Una sola recarga por sim y solo se recargaran DN que pertenezcan a tu distribución.`,
            `Optimiza tu personal y tiempo en realizar las recargas.`
          ]
        },
        {
          img: `./dist/solucion_sms.png`,
          titulo: `SMS`,
          subtitulo: `Es un servicio de mensajería masiva que nos permite enviar SMS de una manera sencilla e intuitiva.`,
          color: `#2F395D`,
          right: false,
          route: `SMS`,
          textos: [
            `Especializado para distribuidores, te hacemos saber que DN de los que envías esta apagado y cual esta encendido, todo a través de un mensaje SMS.`,
            `Realiza campañas masivas incentivando a tus clientes para que realicen recargas.`,
            `¡Aumenta tu calidad y tus ingresos!`,
            `Una sola recarga por sim y solo se recargaran DN que pertenezcan a tu distribución.`,
            `Optimiza tu personal y tiempo en realizar las recargas`
          ]
        }
      ],
      cards: [
        {
          img: `./dist/01_quienessomos.svg`,
          titulo: `¿Quiénes somos?`,
          descripcion: `Somos una empresa de consultoría y desarrollo de software a la medida. Surgimos de la necesidad de brindar soluciones a las tareas repetitivas.<br> <br> Nuestro objetivo es optimizar y automatizar los procesos dentro de su operación.`
        },
        {
          img: `./dist/02_mision.svg`,
          titulo: `Misión`,
          descripcion: `Encontrar una solución funcional, novedosa y elegante a tus necesidades, convirtiéndonos en tu primera opción para mejorar y hacer más eficientes todos tus procesos.`
        },
        {
          img: `./dist/03_vision.svg`,
          titulo: `Nuestra visión`,
          descripcion: `Ser un referente a nivel nacional en la solución de problemas a grandes, medianas y pequeñas empresas con ayuda de la tecnología.`
        },
        {
          img: `./dist/04_tecnologia.svg`,
          titulo: `Tecnología`,
          descripcion: `Utilizamos tecnología de última generación para brindarte eficiencia y seguridad en todas nuestras aplicaciones. Consigue tus objetivos con plataformas 100% innovadoras.`
        }
      ]
    };
  }
};
</script>

<style scoped></style>
